/* SHARED — the dictionaries and the small pieces the card of a visit is drawn with */

/* The states of a booking and the colours the applications give them */
export const STATUSES = [
    { status: 0, text: "Ожидание", color: "green", accent: "orange" },
    { status: 1, text: "Принята", color: "purple", accent: "purple" },
    { status: 2, text: "Завершена", color: "", accent: "blue" },
    { status: 3, text: "Отменена", color: "red", accent: "red" },
    { status: 4, text: "Не пришёл", color: "red", accent: "red" }
]

/* Where the client came from */
export const CHANNELS = {
    app: "Приложение",
    web: "Сайт",
    "2gis": "2ГИС",
    owner: "Заведение",
    qr: "QR код",
    share: "Ссылка"
}

/* What every action of the card does with the visit. The statuses it may be pressed from
   are named here too, so a button which changes nothing is never drawn */
export const ACTIONS = [
    { key: "confirm", text: "Принять", icon: "check", from: [0] },
    { key: "complete", text: "Завершить", icon: "check", from: [0, 1], primary: true },
    { key: "cancel", text: "Отменить", icon: "close", from: [0, 1], danger: true },
    { key: "missed", text: "Не пришёл", icon: "alert", from: [0, 1], danger: true },
    { key: "reopen", text: "Вернуть в работу", icon: "refresh", from: [2, 3, 4] }
]

/* The events of the history — the base keeps the key, the panel says it in Russian */
export const LOG_TYPES = {
    created: "Запись создана",
    status: "Статус изменён",
    member: "Мастер изменён",
    service: "Услуга изменена",
    time: "Время изменено",
    duration: "Длительность изменена",
    client: "Имя клиента изменено",
    phone: "Номер клиента изменён",
    payment: "Оплата записана"
}

/* The states the history writes down instead of the numbers */
export const LOG_STATUSES = {
    created: "Ожидание",
    confirmed: "Принята",
    completed: "Завершена",
    canceled: "Отменена",
    missed: "Не пришёл"
}

/* What happened to a message which went to the client */
export const MESSAGE_STATUSES = {
    sent: { text: "Отправлено", color: "grey" },
    delivered: { text: "Доставлено", color: "green" },
    read: { text: "Прочитано", color: "green" },
    failed: { text: "Ошибка", color: "red" }
}


/* The state of one visit — the row of the list and the card both read it through this */
export const statusOf = value => {

    const found = STATUSES.find(item => item.status === parseInt(value))

    return found ? found : STATUSES[0]
}


/* The money of a visit — what was really charged stands above what was planned */
export const priceOf = booking => {

    if (booking.finalPrice !== null && booking.finalPrice !== undefined && `${booking.finalPrice}` !== "") {
        return parseInt(booking.finalPrice)
    }

    if (booking.endTotal !== null && booking.endTotal !== undefined && `${booking.endTotal}` !== "") {
        return parseInt(booking.endTotal)
    }

    return parseInt(booking.total) ? parseInt(booking.total) : 0
}


/* A sum which came out of the base as a text is still a number */
export const number = value => {

    const parsed = parseFloat(value)

    if (isNaN(parsed)) {
        return 0
    }

    return parsed
}


/* The icon of a visit — it stands in place of the photo of the point the visit belongs to */
export const bookingIcon = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none">
            <path d="M3.9 6.9a1.6 1.6 0 0 1 1.6-1.6h13a1.6 1.6 0 0 1 1.6 1.6v12a1.6 1.6 0 0 1-1.6 1.6h-13a1.6 1.6 0 0 1-1.6-1.6v-12Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            <path d="M8.2 3.4v3.6M15.8 3.4v3.6M3.9 10.4h16.2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <path d="m9.2 15.2 1.9 1.9 3.7-3.7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}


/* One line of the card — the name of the field and its value */
export const line = (text, value, accent = "") => {

    if (value === null || value === undefined || `${value}`.length === 0) {
        return null
    }

    return (
        <div className="booking-details-line" key={text}>
            <div className="booking-details-line-text">{text}</div>
            <div className={`booking-details-line-value ${accent}`}>{value}</div>
        </div>
    )
}
